module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-14.01671a84.svg";